import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

export interface DemoState {
  isDemoMode: boolean;
}

const initialState: DemoState = {
  isDemoMode: false,
};

export const DemoStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setIsDemoMode(isDemoMode: boolean): void {
      patchState(store, { isDemoMode });
    },
  })),
);
